export { default as contentMarketingImageBg } from './contentMarketingImageBg.svg';
export const marketingAutomationImage = require('./marketingAutomationImage.jpg?webp');
export const marketingAutomationImage2x = require('./marketingAutomationImage2x.jpg?webp');
export const contentMarketingImage = require('./contentMarketingImage.jpg?webp');
export const contentMarketingImage2x = require('./contentMarketingImage2x.png?webp');
export const heroBgDark = require('./hero-bg-dark.png?webp');
export const heroBgLight = require('./hero-bg-light.png?webp');
export const bgPhone1x = require('./bg-phone-1x.png?webp');
export const bgPhone2x = require('./bg-phone-2x.png?webp');
export const seoImage1x = require('./seo-image-1x.png?webp');
export const seoImage2x = require('./seo-image-2x.png?webp');
export { default as seoBgSvg } from './seo-bg.svg';
export const smmImage = require('./smm-image-1x.png?webp');
export const smmImage2x = require('./smm-image-2x.png?webp');
